"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { Session } from "next-auth";
import { ProfileMenu } from "./ProfileMenu";

export function MainHeader({ session }: { session: Session | null }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out px-6 md:px-12 py-6 flex justify-between items-center
      ${isScrolled ? "bg-paper/90 backdrop-blur-sm border-b border-gray-200/50" : "bg-transparent"}`}
    >
      <Link href="/" className="flex items-center gap-2">
        <span className="font-serif font-semibold text-xl tracking-tight text-ink">
          Weaven.
        </span>
      </Link>

      <div className="flex items-center gap-6">
        {session ? (
          <ProfileMenu
            userImage={session.user?.image}
            userEmail={session.user?.email}
            hasBlog={!!session.user?.blogUsername}
          />
        ) : (
          <Link
            href="/api/auth/signin"
            className="font-sans text-sm font-medium text-ink border-b border-ink/30 hover:border-ink pb-0.5 transition-all"
          >
            Sign in
          </Link>
        )}
      </div>
    </nav>
  );
}
